/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-01 17:07:43
 */
const sampleOrder = [
	{
		path: '/sample',
		component: null,
		name: '样品',
		id: 2,
		parentId: 0,
		keepAlive: false,
		showBread: true,
		visible: true,
		useTemplate: false,
		redirect: '/sample/list',
		children: [
			{
				path: 'list',
				component: 'sampleOrder/list',
				name: '样品订单',
				parentId: 2,
				keepAlive: false,
				showBread: true,
				visible: true,
				useTemplate: true,
			},
			{
				path: 'importLog',
				component: 'sampleOrder/importLog',
				name: '导入记录',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: false,
				children: null,
			},
		],
	},
];
export default sampleOrder;
